<template>
  <div class="video-player" style="background-color: #1A86D0">
    <div id="stream_player">
      <div id="participant_tracks" class="participant_track">
      </div>
      <div v-show="videoEnabled" id="local_tracks" class="top-right local-track"></div>

      <!--      <div v-else id="default_callbg" class="default_callbg"></div>-->


      <div id="bottom_bar" class="bottom-bar">
        <b-button style="color: white" variant="none" size="xl" :class="(audioEnabled)? '': 'btn-active'" @click="changeAudioState"> audio
        </b-button>
        <b-button style="color: white" variant="none" size="xl" :class="(videoEnabled)? '': 'btn-active'" @click="changeVideoState"> video
        </b-button>

        <b-button variant="danger" size="xl" class="" @click="showEndCallModal = true">end call</b-button>

        <!--    form to end call for checkup-->
        <b-modal id="modal-center" v-model="showEndCallModal" centered title="Finish Checkup">
          <b-form>
            <b-row>
              <b-col>
                <b-form-group label="Tags :" label-for="status">
                  <b-form-checkbox
                      v-model="callStatus"
                      class="mb-3"
                      switch
                  >Call Complete
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group label="Tags :" label-for="patient_tags">
                  <b-form-checkbox-group
                      v-model="checkupeditForm.patient_tags"
                      name="patient_tags"
                      :options="patientTags"
                      class="mb-3"
                      value-field="item"
                      text-field="name"
                      disabled-field="notEnabled"
                  ></b-form-checkbox-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>

          <template v-slot:modal-footer>
            <b-button size="sm" variant="success" @click="confirmCallTerminate">
              Confirm
            </b-button>
            <b-button size="sm" variant="danger" @click="showEndCallModal = false">
              Cancel
            </b-button>

          </template>
        </b-modal>
        <!--    form to end call for checkup-->
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

import CheckupService from '@/services/checkup.service';
import {Form} from "vform";

const Video = require('twilio-video');

export default {
  name: "CallWindow",
  data() {
    return {
      // room: null,
      showEndCallModal: false,
      callStatus: true,
      audioEnabled: true,
      videoEnabled: true,
      room: null,
      patientTags: [
        {item: 'fraud', name: 'fraud'},
      ],
      checkupeditForm: new Form({
        start_time: new Date(),
        end_time: '',
        status: '',
        patient_rating: 5,
        patient_tags: []
      })
    }
  },
  computed: {
    ...mapGetters('doctorCheckup', ['getCallInfo'])
  },
  watch: {},
  methods: {
    ...mapActions('doctorCheckup', ['setCallInfo']),

    reconnect() {
      try {
        this.connectToRoom()
      } catch (e) {
        console.error(e)
        this.reconnect()
      }
    },
    connectToRoom() {
      let participantTrackContainer = document.getElementById('participant_tracks');
      let localTrackContainer = document.getElementById('local_tracks');
      Video.connect(this.getCallInfo.access_token, {
        logLevel: "error", audio: true, maxAudioBitrate: 16000, //For music remove this line
        video: {height: 720, frameRate: 24, width: 1280}
      }).then(room => {
        this.room = room;
        console.log('Connected to Room "%s"', this.room.name);
        // setInterval(() => {
        //   console.log(room);
        // }, 5000)


        window.addEventListener('beforeunload', () => {
          this.room.disconnect();
        });

        this.room.localParticipant.on('trackPublished', (publication) => {
          trackSubscribed(localTrackContainer, publication.track);

        })
        this.room.localParticipant.videoTracks.forEach(publication => {
          trackSubscribed(localTrackContainer, publication.track);

        });


        this.room.participants.forEach(participantConnected);
        this.room.on('participantConnected', participantConnected);

        this.room.on('participantDisconnected', participantDisconnected);
        this.room.once('disconnected', (room, error) => {
          if (error) {
            console.error(error);
            this.reconnect();
          }

          room.participants.forEach(participantDisconnected);
        });

      }).catch((e) => {
        console.error(e);
        this.reconnect();
      });


      function participantConnected(participant) {
        console.log('Participant "%s" connected', participant.sid);

        participant.on('trackSubscribed', track => trackSubscribed(participantTrackContainer, track));
        participant.on('trackUnsubscribed', trackUnsubscribed);

        participant.tracks.forEach(publication => {
          publicationSubscribed(publication, participantTrackContainer);
        });
      }

      function participantDisconnected(participant) {

        console.log('Participant "%s" disconnected', participant.identity);
      }

      function publicationSubscribed(publication, container) {
        if (publication.isSubscribed) {
          trackSubscribed(container, publication.track);
        }
        if (!publication.isSubscribed) {
          publication.on('subscribed', track => {
            // console.error(publication.isSubscribed);
            trackSubscribed(container, track);
          });
        }
      }

      function trackSubscribed(div, track) {
        div.appendChild(track.attach());
        handleTrackDisabled(track);
        handleTrackEnabled(track);
      }

      function trackUnsubscribed(track) {
        track.detach().forEach(element => element.remove());
      }


      function handleTrackEnabled(track) {
        track.on('enabled', () => {
          /* Hide the avatar image and show the associated <video> element. */
        });
      }

      function handleTrackDisabled(track) {
        track.on('disabled', () => {
          /* Hide the associated <video> element and show an avatar image. */
        });
      }
    },

    changeAudioState() {
      if (this.audioEnabled) {
        this.room.localParticipant.audioTracks.forEach(publication => {
          publication.track.disable();
        });
      } else {
        this.room.localParticipant.audioTracks.forEach(publication => {
          publication.track.enable();
        });
      }
      this.audioEnabled = !this.audioEnabled;
    },
    changeVideoState() {
      if (this.videoEnabled) {
        this.room.localParticipant.videoTracks.forEach(publication => {
          publication.track.disable();
        });
      } else {
        this.room.localParticipant.videoTracks.forEach(publication => {
          publication.track.enable();
        });
      }
      this.videoEnabled = !this.videoEnabled;
    },


    confirmCallTerminate() {
      this.checkupeditForm.end_time = new Date();
      this.checkupeditForm.status = (this.callStatus) ? 1 : 2;
      CheckupService.editCheckupAfterCall(this.getCallInfo.checkup_code, this.checkupeditForm)
          .then((response) => {
            if (response.status === 204) {
              this.setCallInfo(null);
              window.close();
            }
          });
    }
  },
  mounted() {
    console.info('starting connection');
    document.addEventListener('beforeunload', () => {
      this.setCallInfo(null)
    });

    this.connectToRoom();
  }

}
</script>

<style src="./CallWindow.scss" lang="scss"/>
